import React from "react";
import { Dropdown } from "react-bootstrap";
import "../../style/main.scss";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import Web3 from "web3";

const AnalyticsCollection = (props) => {

  const web3 = new Web3();
  const [collectionData, setCollectionData] = useState([]);
  const [volume, setVolume] = useState(0);
  const [floorPrice, setFloorPrice] = useState(0);
  const [saleCount, setSaleCount] = useState(0);
  const [floorPriceData, setFloorPriceData] = useState({
    date: [],
    price: [],
  });
  const [volumeData, setVolumeData] = useState({
    date: [],
    price: [],
  });

  const convertWeiToEther = (priceInWei) => {
    if (priceInWei) {
      try {
        // Convert the price from wei to ether, ensuring the input is a string
        const priceInEther = web3.utils.fromWei(priceInWei.toString(), "ether");
        return priceInEther;
      } catch (error) {
        console.error('Error converting Wei to Ether:', error);
        return null;
      }
    }
    return null; // Return null or handle cases where priceInWei is falsy
  };
  

  useEffect(() => {
    console.log(props?.stats, "prosp in analytices");

    if (props.stats) {
      setCollectionData(props?.stats);
      setSaleCount(props?.stats?.saleCount);
      if (props?.stats?.volume?.length > 0) {
        setVolume(
          convertWeiToEther(props?.stats?.volume[props?.stats?.volume?.length - 1].split("-")[0])
        );
        const volumeFilter = props?.stats?.volume.map((item) => {
          const [price, timestamp] = item.split("-");
          const date = new Date(parseInt(timestamp))
            .toISOString()
            .split("T")[0];
          return { date, price };
        });


        setVolumeData({
          date: volumeFilter.map((item) => item.date),
          price: volumeFilter.map((item) => convertWeiToEther(item.price)),
        });
      }
      if (props?.stats?.floorPrice?.length > 0) {
        setFloorPrice(convertWeiToEther(props?.stats?.floorPrice[props?.stats?.floorPrice?.length - 1].split(
          "-"
        )[0])
          || "0"
        );

        const floorPriceFilter = props?.stats?.floorPrice.map((item) => {
          const [Price, timestamp] = item.split("-");
          let price = convertWeiToEther(Price);
          const date = new Date(parseInt(timestamp))
            .toISOString()
            .split("T")[0]; // Convert milliseconds to Date and get YYYY-MM-DD format
          console.log("Date item", date);
          return { date, price };
        });


        setFloorPriceData({
          date: floorPriceFilter.map((item) => item.date),
          price: floorPriceFilter.map((item) => item.price),
        });
      }
    }
  }, [props?.stats]);

  const floorPriceState = {
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: floorPriceData.date,
      },
    },
    series: [
      {
        name: "series-1",
        data: floorPriceData.price,
      },
    ],
  };

  const volumeState = {
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: volumeData.date,
      },
    },
    series: [
      {
        name: "series-1",
        data: volumeData.price,
      },
    ],
  };

  return (
    <div>
      <div className="analytics ">

        <div className="valueBox-wrapper mt-30 d-flex">
          <div className="value-box">
            <p className="body-medium">Floor Price</p>
            <h5 className="font-26 fw-bold no-text-transform">
              {(floorPrice)} FLR
            </h5>
          </div>

          <div className="value-box">
            <p className="body-medium">Volume</p>
            <h5 className="font-26 fw-bold no-text-transform">{volume} FLR</h5>
          </div>

          <div className="value-box">
            <p className="body-medium">Sales</p>
            <h5 className="font-26 fw-bold no-text-transform">
              {collectionData?.saleCount}
            </h5>
          </div>
        </div>

        <div className="analysis-chart v-center   ">
          <div className="analysis  ">
            <div id="chart_div" className="overflow-hidden">
              <Chart
                options={volumeState.options}
                series={volumeState.series}
                type="line"
                width="400px"
                className="volume-chart mt-5"
              />
            </div>
            <label htmlFor="" className="text-black no-text-transform">
              Volume
            </label>
          </div>
          <div className="analysis">
            <div id="chart_div" className="overflow-hidden">
              <Chart
                options={floorPriceState.options}
                series={floorPriceState.series}
                type="line"
                width="400px"
                className="volume-chart mt-5"
              />
            </div>
            <label htmlFor="" className="text-black no-text-transform">
              Floor Price
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsCollection;
